import { createFromIconfontCN } from '@ant-design/icons';

const Icon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3844111_a0iy8n4djrg.js',
});

export default Icon;
